var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"description":"您访问的页面丢失了"}},[_c('van-button',{staticClass:"bottom-button",attrs:{"round":"","type":"default"},on:{"click":function($event){return _vm.goback()}}},[_vm._v(" 返回上一页 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }